import React, { useContext } from "react";
import { useState, useEffect } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup, Table } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "react-phone-input-2/lib/bootstrap.css";
import { Context } from "../../../../utils/context";
import "bootstrap/dist/css/bootstrap.min.css";

library.add(fas);

const ViewOffCanvance = (props) => {
  console.log(props.data);

  const { getData, IMG_URL } = useContext(Context);

  const [data, setData] = useState(props.data);
  const [formData, setFormData] = useState();
  // console.log(data,"data");
  const GetEditData = async () => {
    const response = await getData(`/customers/rides/${data}`);
    setFormData(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);
  console.log(formData, "formData");
  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%", height: "auto" }}
        placement={"end"}
        onHide={props.handleClose}
        className="offcan"
      >
        <Container className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5 bg-white rounded">
              <Card.Body>
                <Card.Title>
                  <h3>Booking Details </h3>
                </Card.Title>

                <Box sx={{ width: "100%", typography: "body1" }}>
                  <div className="row mt-3" style={{ overflowX: "scroll" }}>
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            <th className="tax-name">Customer Name </th>

                            <th className="tax-name">Vehicle Category </th>

                            <th className="tax-name">Vehicle </th>

                            <th className="tax-name">Quantity Type </th>

                            <th className="tax-name">Goods type </th>

                            {/* <th className="tax-name">Initial Fare </th>
                            <th className="tax-name">Initial Distance </th>
                            <th className="tax-name">Final Distance </th>
                            <th className="tax-name">Final Amount </th> */}

                            <th className="tax-name">Payment Type </th>

                            <th className="tax-name">Driver</th>

                            <th className="tax-name">Payment Status</th>

                            <th className="tax-name">Booking Date</th>

                            <th className="tax-name">Booking Time</th>

                            <th className="tax-name">Customer Signature</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {formData?.user?.f_name || "N/A"}{" "}
                              {formData?.user?.l_name || "N/A"}
                            </td>
                            <td>
                              {formData?.vehicle_type?.vehicle_category?.name ||
                                "N/A"}
                            </td>
                            <td>{formData?.vehicle_type?.name || "N/A"}</td>
                            <td>{formData?.quantity_type?.name || "N/A"}</td>
                            <td>{formData?.goods_type?.name || "N/A"}</td>
                            {/* <td>₹{formData?.amount || "N/A"}</td>
                            <td>{formData?.distance || "N/A"} KM</td>
                            <td>{formData?.final_distance || 0} KM</td>
                            <td>₹ {formData?.final_amount || 0} </td> */}
                            <td>{formData?.payment_type || "N/A"}</td>
                            <td>{formData?.Driver?.f_name || "N/A"}</td>
                            <td>
                              {formData?.payment_status == 1
                                ? "Paid"
                                : "Unpaid" || "N/A"}
                            </td>{" "}
                            {/* <td>
                              {formData?.payment_status == 1
                                ? "Paid"
                                : "Unpaid" || "N/A"}
                            </td>{" "} */}
                            <td>
                              {formData?.createdAt
                                ? new Date(
                                    formData.createdAt
                                  ).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  })
                                : "N/A"}
                            </td>
                            <td>
                              {formData?.createdAt
                                ? new Date(formData.createdAt).toLocaleString(
                                    "en-GB",
                                    {
                                      // day: "2-digit",
                                      // month: "long",
                                      // year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    }
                                  )
                                : "N/A"}
                            </td>
                            <td>
                              {formData?.customer_signature && (
                                <img
                                  src={`${IMG_URL}${formData.customer_signature}`}
                                  alt="Image"
                                  width="120"
                                  height="100"
                                />
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      <div className="mt-5">
                        <h5>
                          {" "}
                          <b> Drop Details</b>
                        </h5>
                        <Table striped bordered hover responsive center>
                          <thead>
                            <tr className="">
                              {/* <th className="tax-name">Sr. No.</th> */}

                              <th className="tax-name">Pickup Latitude </th>

                              <th className="tax-name">Pickup Longitude </th>

                              <th className="tax-name">Pickup Address </th>

                              <th className="tax-name">Receiver Name </th>

                              <th className="tax-name">
                                Receiver Contact Number{" "}
                              </th>

                              <th className="tax-name">Drop Stop </th>

                              <th className="tax-name">Drop Latitude </th>

                              <th className="tax-name">Drop Longitude </th>

                              <th className="tax-name">Drop Address </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{formData?.pickup_lat || "N/A"}</td>
                              <td>{formData?.pickup_long || "N/A"}</td>
                              <td>{formData?.pickup_address || "N/A"}</td>{" "}
                              <td>
                                {formData?.booking_drop_details?.length > 0 ? (
                                  formData.booking_drop_details.map(
                                    (data, index) => (
                                      <tr key={index}>
                                        <td>{data?.receiver_name || "N/A"}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td>No drop details available</td>
                                  </tr>
                                )}
                              </td>{" "}
                              <td>
                                {formData?.booking_drop_details?.length > 0 ? (
                                  formData.booking_drop_details.map(
                                    (data, index) => (
                                      <tr key={index}>
                                        <td>
                                          {data?.receiver_contact_no || "N/A"}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td>No drop details available</td>
                                  </tr>
                                )}
                              </td>
                              <td>
                                {formData?.booking_drop_details?.length > 0 ? (
                                  formData.booking_drop_details.map(
                                    (data, index) => (
                                      <tr key={index}>
                                        <td>{data?.drop_stop || "N/A"}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td>No drop details available</td>
                                  </tr>
                                )}
                              </td>
                              <td>
                                {formData?.booking_drop_details?.length > 0 ? (
                                  formData.booking_drop_details.map(
                                    (data, index) => (
                                      <tr key={index}>
                                        <td>{data?.drop_lat || "N/A"}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td>No drop details available</td>
                                  </tr>
                                )}
                              </td>
                              <td>
                                {formData?.booking_drop_details?.length > 0 ? (
                                  formData.booking_drop_details.map(
                                    (data, index) => (
                                      <tr key={index}>
                                        <td>{data?.drop_long || "N/A"}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td>No drop details available</td>
                                  </tr>
                                )}
                              </td>
                              <td>
                                {formData?.booking_drop_details?.length > 0 ? (
                                  formData.booking_drop_details.map(
                                    (data, index) => (
                                      <tr key={index}>
                                        <td>{data?.drop_address || "N/A"}</td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td>No drop details available</td>
                                  </tr>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>

                      <div className="mt-5">
                        <h5>
                          {" "}
                          <b> Distance / Payment Details</b>
                        </h5>
                        <Table striped bordered hover responsive center>
                          <thead>
                            <tr className="">
                              {/* <th className="tax-name">Sr. No.</th> */}

                              <th className="tax-name">Initial Distance </th>

                              <th className="tax-name">Initial Fare </th>

                              <th className="tax-name">Extra Distance </th>

                              <th className="tax-name">Extra Fare </th>

                              <th className="tax-name">Total Distance </th>

                              <th className="tax-name">Total Fare </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {(Number(formData?.distance) || 0).toFixed(2)}{" "}
                                KM
                              </td>
                              <td>
                                ₹ {(Number(formData?.amount) || 0).toFixed(2)}
                              </td>
                              <td>
                                {(
                                  Number(formData?.extra_distance) || 0
                                ).toFixed(2)}{" "}
                                KM
                              </td>
                              <td>
                                ₹{" "}
                                {(Number(formData?.extra_amount) || 0).toFixed(
                                  2
                                )}
                              </td>
                              <td>
                                {(
                                  Number(formData?.final_distance) || 0
                                ).toFixed(2)}{" "}
                                KM
                              </td>
                              <td>
                                ₹{" "}
                                {(Number(formData?.final_amount) || 0).toFixed(
                                  2
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </Box>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
        </Container>
      </Offcanvas>
    </>
  );
};

export default ViewOffCanvance;
